import { render, staticRenderFns } from "./CultureAssetPurchaseInfo.vue?vue&type=template&id=7b631eb4&scoped=true&"
import script from "./CultureAssetPurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./CultureAssetPurchaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b631eb4",
  null
  
)

export default component.exports